import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Negobill Admin -";
const routes = [
  { path: "/dashboard", title: `${BASE_TITLE} Dashboard` },
  { path: "/login", title: `${BASE_TITLE} Login` },
  { path: "/forgot-password", title: `${BASE_TITLE} Forgot Password` },
  { path: "/reset-password", title: `${BASE_TITLE} Reset Password` },
  { path: "/verify-otp", title: `${BASE_TITLE} Otp Verification` },
  { path: "/all-stores", title: `${BASE_TITLE} All Stores` },
];

const DynamicTitleAndIcon = () => {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = routes.find(
      (route) => route.path === location.pathname
    );

    document.title = currentRoute ? currentRoute.title : "Negobill - Dashboard";

    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = "/assets/images/favicon.png";
    }
  }, [location.pathname]);

  return null;
};

export default DynamicTitleAndIcon;
